// extracted by mini-css-extract-plugin
module.exports = {"LeftSide":"SplitLabel_LeftSide__1dR7k","RightSide":"SplitLabel_RightSide__2kTCA"};